import { ReactComponent as Amex } from './amex-card.svg'
import { ReactComponent as CreditCard } from './credit-card.svg'
import { ReactComponent as Diners } from './diners-card.svg'
import { ReactComponent as Discover } from './discover-card.svg'
import { ReactComponent as JCB } from './jcb-card.svg'
import { ReactComponent as MasterCard } from './mc-card.svg'
import { ReactComponent as Union } from './union-pay-card.svg'
import { ReactComponent as Visa } from './visa-card.svg'

const cards = {
  Visa,
  Diners,
  Discover,
  MasterCard,
  JCB,
  Union,
  Amex
}
const CreditCardIcon = ({ type }) => {
  const Icon = cards[type]

  return Icon ? <Icon /> : <CreditCard />
}

export default CreditCardIcon
